import React from "react";

export default function ML_BrainJS() {
  return (
    <div>
      <h1>ML_BrainJS</h1>
      <p>This is the ML_BrainJS component.</p>
    </div>
  );
}
